import handleError from './handleError';
function pushToDataLayer(obj) {
  if (typeof window === 'undefined' || !Array.isArray(window.dataLayer)) {
    console.warn('Tried to push to the window.dataLayer but it has not been initialized');
    return;
  }
  if (obj === null || typeof obj !== 'object') {
    handleError(new Error("pushToDataLayer called with \"".concat(obj, "\", it must be an object!")));
  }
  window.dataLayer.push(obj);
}
export default pushToDataLayer;